import { SolIcon } from '@sol/icons';

import { SolValidationMessage } from '../../../models/core/sol-validation-message';
import { IconTools } from '../../../tools/icon-tools';
import { ObjectTools } from '../../../tools/object-tools';

export class SolValidationMessagesState {
  private constructor(
    public readonly showAll: boolean,
    public readonly messages: SolValidationMessage[],
    public readonly visibleMessages: SolValidationMessage[],
    public readonly messageClasses: string[],
    public readonly icons: (SolIcon | undefined)[],
  ) {}

  public static of(): SolValidationMessagesState {
    return new SolValidationMessagesState(false, [], [], [], []);
  }

  public withMessages(messages: SolValidationMessage[]): SolValidationMessagesState {
    return this.copy({ messages }).recalculate();
  }

  public withShowAll(showAll: boolean): SolValidationMessagesState {
    return this.copy({ showAll }).recalculate();
  }

  private recalculate(): SolValidationMessagesState {
    const visibleMessages = this.showAll ? this.messages : this.messages.slice(0, 1);
    const messageClasses = this.messages.map(
      message => `sol-validation-message sol-validation-message-${message.type}`,
    );
    const icons = this.messages.map(message => IconTools.fromValidationType(message.type));
    return this.copy({ visibleMessages, messageClasses, icons });
  }

  private copy(props: Partial<SolValidationMessagesState>): SolValidationMessagesState {
    return ObjectTools.copy<SolValidationMessagesState>(this, props);
  }
}
